export default {
  namespaced: true,
  state: {
    all: [],
    loading: false,
    timestamp: null,
  },
  getters: {
    all: (state) => state.all,
    loading: (state) => state.loading,
    timestamp: (state) => state.timestamp,
  },
  mutations: {
    startLoading(state) { state.loading = true },
    stopLoading(state) { state.loading = false },
    setAll(state, analytics) {
      state.all = analytics
      state.timestamp = new Date()
      state.loading = false
    },
  },
  actions: {
    fetchAll({ commit }) {
      commit('startLoading')
      return Vue.$http
        .get('client/organization/analytics/applicants')
        .then(
          (response) => commit('setAll', response.data),
          (response) => commit('stopLoading')
        )
    },
  },
}
